import {
	DndContext,
	DragEndEvent,
	DragOverlay,
	PointerSensor,
	TouchSensor,
	closestCenter,
	useSensor,
	useSensors,
} from '@dnd-kit/core';
import { SortableContext, rectSortingStrategy } from '@dnd-kit/sortable';
import {
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	styled,
} from '@mui/material';
import SortableArticlesItem from './SortableArticlesItem';
import { useTranslation } from 'react-i18next';
import { SortSubFaqListDTO } from '@/api/DTO/information/subFaq.interface';

interface DndArticleListSectionProps {
	subFaqItems: any;
	handleRepositionItem: (activeIndex: number, overIndex: number) => void;
}

export default function DndArticleListSection({
	subFaqItems,
	handleRepositionItem,
}: DndArticleListSectionProps) {
	const { t } = useTranslation();

	// for input methods detection
	const sensors = useSensors(useSensor(PointerSensor), useSensor(TouchSensor));

	// triggered when dragging ends
	const handleDragEnd = (event: DragEndEvent) => {
		const { active, over } = event;
		if (!over) return;

		const activeItem = subFaqItems.find(
			(item: SortSubFaqListDTO) => item.id === active.id
		);
		const overItem = subFaqItems.find(
			(item: SortSubFaqListDTO) => item.id === over.id
		);

		if (!activeItem || !overItem) {
			return;
		}

		const activeIndex = subFaqItems.findIndex(
			(item: SortSubFaqListDTO) => item.id === active.id
		);
		const overIndex = subFaqItems.findIndex(
			(item: SortSubFaqListDTO) => item.id === over.id
		);

		if (activeIndex !== overIndex) {
			handleRepositionItem(activeIndex, overIndex);
		}
	};

	return (
		<DndContext
			sensors={sensors}
			collisionDetection={closestCenter}
			onDragEnd={handleDragEnd}
		>
			<SortableContext
				items={subFaqItems.map((i: { id: SortSubFaqListDTO }) => i.id)}
				strategy={rectSortingStrategy}
			>
				<TableContainer>
					<Table>
						<TableHead>
							<TableRow
								sx={{
									backgroundColor: '#EEF1F6',
								}}
							>
								<StyledTableCell>{t('subFaq.questionZh')}</StyledTableCell>
								<StyledTableCell>{t('subFaq.answerZh')}</StyledTableCell>
								<StyledTableCell>{t('subFaq.questionEn')}</StyledTableCell>
								<StyledTableCell>{t('subFaq.answerEn')}</StyledTableCell>
								<StyledTableCell>{t('subFaq.updatedAt')}</StyledTableCell>
								<StyledTableCell>{t('subFaq.createdAt')}</StyledTableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{subFaqItems?.map((item: SortSubFaqListDTO) => (
								<SortableArticlesItem key={item.id} item={item} />
							))}
						</TableBody>
					</Table>
				</TableContainer>
				<DragOverlay />
			</SortableContext>
		</DndContext>
	);
}

const StyledTableCell = styled(TableCell)({
	fontWeight: 'normal',
	minWidth: '190px',
});
